import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

const ConditionFilter = ({ filters, setFilters }) => {
  const conditions = ['Novo', 'Rabljeno', 'Poškodovano'];
  
  const handleConditionChange = (event) => {
    const condition = event.target.value;
    const newConditions = filters.itemCondition.includes(condition)
      ? filters.itemCondition.filter((item) => item !== condition)
      : [...filters.itemCondition, condition];
    setFilters({ ...filters, itemCondition: newConditions });
  };
  
  return (
    <div className="condition-filter">
      <h3>Stanje</h3>
      <FormGroup style={{ gap: '4px', alignItems: 'flex-start' }}>
        {conditions.map((condition) => (
          <FormControlLabel
            key={condition}
            control={
              <Checkbox
                value={condition}
                checked={filters.itemCondition.includes(condition)}
                onChange={handleConditionChange}
                color="secondary"
                sx={{
                  '&.Mui-checked': {
                    color: '#FF4367', // Custom color when checked
                  }
                }}
                size="small"
              />
            }
            label={condition}
            style={{ margin: 0, marginLeft: '-11px' }}
          />
        ))}
      </FormGroup>
    </div>
  );
};

export default ConditionFilter;